function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import SideModal from "../../../../Common/SideModal";
import GrClose from "@meronex/icons/gr/GrClose";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var question = [{
  id: 200,
  question: "Can't find what you're looking for? Let us know what you need, and we'll source it for you!",
  type: "FREE"
}];
function MiniSurvey(_ref) {
  var _question$;
  var showSurvey = _ref.showSurvey,
    handleCloseSurvey = _ref.handleCloseSurvey,
    config = _ref.config,
    winnreAuth = _ref.winnreAuth;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    comment = _useState2[0],
    setComment = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    formIsValid = _useState6[0],
    setFormIsValid = _useState6[1];
  var commentsChangedHandler = function commentsChangedHandler(event) {
    setComment(event.target.value);
  };
  useEffect(function () {
    if (comment != "") {
      setFormIsValid(true);
    }
  }, [comment]);
  var handleSubmit = function handleSubmit() {
    var answer = "";
    if (question[0].type === "FREE") {
      if (!comment.trim()) {
        return;
      }
      answer = comment;
    }
    winnreAuth === null || winnreAuth === void 0 || winnreAuth({
      method: "POST",
      url: "winnre/user/mini-survey-answer/submit",
      data: {
        answer: answer,
        questionId: question[0].id,
        answerSource: "WEB",
        userSyncClientId: config.id
      }
    }).then(function (res) {
      var _window;
      // if (res.status === 'FAILED') {
      //     console.log('survey response', res);
      //     setLoading(true);
      //     return;
      // }

      (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("SurveyAnswered", {
        questionsId: question[0].id,
        questionText: question,
        answerText: answer
      });
      // setShowSurvey(false);
      handleCloseSurvey();
    })["catch"](function (error) {
      console.error("Submission error:", error);
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(SideModal, {
      visible: showSurvey,
      survey: true,
      className: "w-full  lg:pl-[15%] lg:pr-[15%]",
      config: config
      // onClick={() => {
      //     setShowSurvey(false);
      // }}
      ,
      onClick: handleCloseSurvey,
      children: /*#__PURE__*/_jsxs("div", {
        className: "relative p-2 lg:p-4 flex flex-col ",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex flex-row gap-2",
          children: [/*#__PURE__*/_jsx("img", {
            className: "w-[50px] h-[50px]",
            src: "https://cdn.loyalie.in/1722926441360_question_gif"
          }), /*#__PURE__*/_jsx("h3", {
            className: "font-medium text-base md:text-lg  pr-10  p-2 ",
            children: (_question$ = question[0]) === null || _question$ === void 0 ? void 0 : _question$.question
          })]
        }), /*#__PURE__*/_jsx(GrClose
        // onClick={() => setShowSurvey(false)}
        , {
          onClick: handleCloseSurvey,
          className: "self-center h-4 w-4 cursor-pointer absolute right-5 top-5"
        }), question[0].type === "FREE" && /*#__PURE__*/_jsx("div", {
          className: "flex items-center  h-16 lg:h-18 xl:h-20  rounded-lg border border-[#dddddd] p-2 ml-2 lg:ml-[4.5rem] md:ml-[4.5rem]",
          children: /*#__PURE__*/_jsx("textarea", {
            type: "text",
            placeholder: "Paste the link here",
            className: " text-black outline-none  w-full  text-grey-900 placeholder:mt-4",
            onChange: commentsChangedHandler,
            value: comment
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "w-full flex flex-row gap-2 mt-4 justify-start md:justify-end lg:justify-end",
          children: /*#__PURE__*/_jsx("button", {
            className: "sub-btn px-6 md:px-6 text-white disabled:opacity-70 disabled:bg-gray-400 disabled:cursor-not-allowed",
            onClick: handleSubmit,
            disabled: !formIsValid,
            children: "Submit"
          })
        })]
      })
    })
  });
}
export default MiniSurvey;